import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { ProjectService } from '../../services/project.service';
import { ConsultationService } from '../../services/consultation.service';
import { Project } from '../../models/project.model';
import { onImageError } from '../../utils/media-url.util';

@Component({
  selector: 'app-projects-gallery',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './projects-gallery.component.html',
  styleUrl: './projects-gallery.component.scss'
})
export class ProjectsGalleryComponent {
  private router = inject(Router);
  private projectService = inject(ProjectService);
  private consultationService = inject(ConsultationService);

  selectedCategory = this.projectService.selectedCategory;
  filteredProjects = this.projectService.filteredProjects;
  activeLightboxProject = this.projectService.activeLightboxProject;
  onImgErr = onImageError;

  categories = [
    { id: 'all', label: 'ALL PROJECTS' },
    { id: 'custom', label: 'CUSTOM RESIDENCES' },
    { id: 'rebuild', label: 'KNOCK DOWN & REBUILD' },
    { id: 'duplexDesigns', label: 'DUPLEX DESIGNS' }
  ];

  setCategory(catId: string) {
    this.projectService.setCategory(catId);
  }

  goToProjectDetail(projId: string, event: Event) {
    event.stopPropagation();
    this.router.navigate(['/project', projId]);
  }

  openProject(proj: Project) {
    this.router.navigate(['/project', proj.id]);
  }

  closeLightbox() {
    this.projectService.closeLightbox();
  }

  bookForProject(projTitle: string) {
    this.closeLightbox();
    this.consultationService.openModal({ projectType: `Inquiry regarding ${projTitle}` });
  }
}
